var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-top"},[_c('img',{attrs:{"src":_vm.imageSrc(_vm.bgImg),"alt":""}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.mainTitle))]),_c('p',{staticClass:"sub"},[_vm._v(_vm._s(_vm.subTitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }